import { FC } from 'react';
import { ArrayKit } from '@team/array';
import { Layout } from './layout';

type Props = {
  target: number;
  count: number;
};

export const Entry: FC<Props> = ({ target, count }) => {
  if (ArrayKit.isNotFoundElement(target)) {
    return null;
  }

  return (
    <Layout
      style={{
        width: `${100 / count}%`,
        transform: `translateX(${100 * target}%)`,
      }}
    />
  );
};
